export default "__VITE_ASSET__a829fc65__"